import axios from 'axios';
import { BanAppeal, BanAppealReply, PaginatedResponse } from './types';

export interface BanAppealCreatePayload {
    country: string;
    isp: string;
    ban_reason_guess: string;
    account_shared: boolean;
    message?: string;
}

export const banAppeals = {
    me() {
        return axios.get<{ appeal: BanAppeal | null }>('ban-appeals/me');
    },
    create(payload: BanAppealCreatePayload) {
        return axios.post<{ appeal: BanAppeal }>('ban-appeals', payload);
    },
    reply(id: number, message: string) {
        return axios.post<{ reply: BanAppealReply }>(`ban-appeals/${id}/replies`, { message });
    },
    list(status = 'open', limit = 50, page = 0) {
        return axios.get<PaginatedResponse<BanAppeal>>('ban-appeals', {
            params: { status, limit, page },
        });
    },
    get(id: number) {
        return axios.get<{ appeal: BanAppeal }>(`ban-appeals/${id}`);
    },
    accept(id: number, admin_note?: string) {
        return axios.post<{ appeal: BanAppeal }>(`ban-appeals/${id}/accept`, { admin_note });
    },
    deny(id: number, admin_note?: string) {
        return axios.post<{ appeal: BanAppeal }>(`ban-appeals/${id}/deny`, { admin_note });
    },
};
